import {
  bffFetchTrustpilotProductReviews,
  bffFetchTrustpilotProductSummary,
} from "@made-people/grease-bff";
import {
  transformTrustpilotProductReviewsToDisplay,
  type TrustpilotDisplayData,
} from "@made-people/grease-trustpilot";
import type { BffClient } from "@made-people/gears-bff-client";
import { cacheKey } from "../../utils/create-cache-keygen";
import { createPromiseDedupe } from "../../utils/create-promise-dedupe";

interface FetchProductReviewsOptions {
  productSku: string;
  language: string;
  perPage?: number;
  page?: number;
}

const cache = new Map<string, TrustpilotDisplayData | null>();
const dedupe = createPromiseDedupe<TrustpilotDisplayData | null>();

export async function fetchTrustpilotProductReviews(
  bffClient: BffClient,
  options: FetchProductReviewsOptions,
): Promise<TrustpilotDisplayData | null> {
  try {
    const key = cacheKey(options);
    if (cache.has(key)) {
      return cache.get(key) ?? null;
    }

    return dedupe(key, async () => {
      const [response, summary] = await Promise.all([
        bffFetchTrustpilotProductReviews(bffClient, {
          productSku: options.productSku,
          perPage: options.perPage ?? 12,
          page: options.page ?? 1,
          language: options.language,
        }),
        bffFetchTrustpilotProductSummary(bffClient, {
          productSku: options.productSku,
        }),
      ]);

      const data =
        response?.productReviews && response.productReviews.length > 0
          ? transformTrustpilotProductReviewsToDisplay(response, summary)
          : null;
      cache.set(key, data);
      return data;
    });
  } catch (error) {
    console.error("[fetchTrustpilotProductReviews] Error:", error);
    return null;
  }
}
